import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import * as actions from "./actions";
import * as utils from "../utils";

import GrowingTextarea from "../common/components/growing-textarea";
import JifitiGiftLink from "../common/components/jifiti-gift-link";
import RouterLink from "../common/components/router-link";

import { connect } from 'react-redux';

const Rsvp = React.createClass({
  render: function() {
    const isMobile = utils.isMobile();
    return (
      <div className="rsvp-panel">
        { isMobile &&
          <MobileInvitationDesign />
        }
        <div className="simple-shadowbox rsvp-form-container">
          <RsvpForm state={this.props.state.rsvp} />
          <JifitiGiftLink compactVersion={true} />
        </div>
        <EventActions />
        <FromHostPanel
          hasPoll={this.props.state.hasPoll}
          hasWhatToBring={this.props.state.hasWhatToBring}
        />
      </div>
    )
  }
});

const RsvpForm = React.createClass({
  componentDidMount() {
    if (this.props.state.showForm && !window.is_mobile_site && !window.is_preview) {
      this.focusCommentInput();
    }
  },
  componentDidUpdate(prevProps) {
    if (!prevProps.state.showForm && this.props.state.showForm && !window.is_mobile_site && !window.is_preview) {
      this.focusCommentInput();
    }
  },
  getInitialState() {
    return {
      validationErrors: {}
    };
  },
  render() {
    if (this.props.state.showForm) {
      if (window.evite_event.status === "cancelled") {
        return (
          <h3 className="feed-notice">
            RSVP closed - this event has been canceled
          </h3>
        )
      }
      if (utils.eventHasPassed()) {
        return (
          <h3 className="feed-notice">
            RSVP closed - this event has already occurred
          </h3>
        )
      }
      if (window.is_preview) {
        return (
          <h3 className="feed-notice">
            RSVP closed in preview mode
          </h3>
        )
      }
      return (
        <div className="rsvp-form-wrap">
          <h1>
            Will you attend?
            { this.props.state.hasRsvpd &&
              <a href="#" onClick={this.toggleShowRsvpForm} className="cancel-rsvp-form">Cancel</a>
            }
          </h1>
          <RsvpResponseButtons
            rsvpResponse={this.props.state.rsvpResponse}
            formSubmitting={this.props.state.formSubmitting}
          />
          <form onSubmit={this.handleSubmit}>
            { this.props.state.inGuestlist ?
              <ReplyingAs
                editingName={this.props.state.editingName}
                guestName={this.props.state.guestName}
                altGuestName={this.props.state.altGuestName}
                hasRsvpd={this.props.state.hasRsvpd}
                validationErrors={this.state.validationErrors}
              />
              :
              <NameEmailInputs
                guestName={this.props.state.guestName}
                guestEmail={this.props.state.guestEmail}
                storedGuestName={this.props.state.storedGuestName}
                storedGuestEmail={this.props.state.storedGuestEmail}
                formSubmitting={this.props.state.formSubmitting}
                validationErrors={this.state.validationErrors}
              />
            }
            <fieldset>
              <GrowingTextarea
                textareaValue={this.props.state.comment}
                handleCommentChange={this.handleCommentChange}
                handleSubmit={this.handleSubmit}
                placeholder="Add a comment..."
                initialRows="2"
                ref="commentInput"
                isDisabled={this.props.state.formSubmitting}
              />
            </fieldset>
            { this.props.state.allowGuests && this.props.state.rsvpResponse !== "no" &&
              <TotalGuests
                maxGuests={this.props.state.maxGuests + 1}
                totalAdults={this.props.state.totalAdults}
                totalKids={this.props.state.totalKids}
                allowKids={this.props.state.allowKids}
                formSubmitting={this.props.state.formSubmitting}
                validationErrors={this.state.validationErrors}
              />
            }
            { this.props.state.showNotifyMarketing &&
              <NotificationInputs
                notifyMarketing={this.props.state.notifyMarketing}
                formSubmitting={this.props.state.formSubmitting}
              />
            }
            <fieldset className="rsvp-submit">
              <button
                id="rsvp-send"
                className="button-primary"
                disabled={this.props.state.formSubmitting}
              >
                {this.props.state.hasRsvpd ? "Update Reply" : "Reply"}
              </button>
            </fieldset>
          </form>
        </div>
      );
    } else {
      return (
        <div className="rsvp-form-wrap you-replied">
          <h1>
            You replied
            <span className={this.props.state.rsvpResponse}>
              &nbsp;{this.props.state.rsvpResponse}
            </span>
            { !this.props.state.preventRsvp &&
              <a href="#" className="link-style" onClick={this.toggleShowRsvpForm}>
                Change Reply
              </a>
            }
          </h1>
        </div>
      );
    }
  },
  focusCommentInput() {
    if (this.refs.commentInput) {
      ReactDOM.findDOMNode(this.refs.commentInput).focus()
    }
  },
  handleSubmit(e) {
    const formData = {
      topic_id: window.topic_id,
      guest_id : this.props.state.guestId,
      name : this.props.state.altGuestName.trim() || this.props.state.guestName.trim(),
      email: this.props.state.guestEmail.trim(),
      comments: this.props.state.comment.trim(),
      optin: this.props.state.notifyMarketing,
      response: this.props.state.rsvpResponse,
      adults_in_party: this.props.state.totalAdults,
      kids_in_party: this.props.state.totalKids,
      email_new_comments: this.props.state.notifyNewComments,
      email_new_rsvp: this.props.state.notifyNewRsvp,
      is_anonymous: this.props.state.isAnonymous,
    };
    e.preventDefault();
    if (formData.name === "") {
      this.setState({
        validationErrors: {
          guestName: "Please enter a name"
        }
      });
      return false;
    }
    if (this.props.state.editingName && this.props.state.altGuestName.trim() === "" && formData.name === "") {
      this.setState({
        validationErrors: {
          guestName: "Please enter a name"
        }
      });
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      this.setState({
        validationErrors: {
          guestEmail: "Enter valid email"
        }
      });
      return false;
    }
    if (formData.adults_in_party < 0) {
      this.setState({
        validationErrors: {
          totalAdults: "Enter valid number"
        }
      });
      return false;
    }
    if (formData.kids_in_party < 0) {
      this.setState({
        validationErrors: {
          totalKids: "Enter valid number"
        }
      });
      return false;
    }
    actions.submitRsvp(formData);
  },
  toggleShowRsvpForm(e) {
    e.preventDefault();
    actions.toggleRsvpFormVisible();
  },
  handleCommentChange(e) {
    actions.setRsvpComment(e.target.value);
  }
});

const RsvpResponseButtons = React.createClass({
  render: function() {
    const possibleResponses = window.is_premium ? ["yes", "no"] : ["yes", "maybe", "no"];
    const responses = possibleResponses.map((response, index) => {
      const rsvpResponse = this.props.rsvpResponse;
      return (
        <li key={index} style={{ width: (100 / possibleResponses.length) + "%" }}>
          <a
              href="#"
              onClick={this.changeResponse.bind(this, response)}
              className={rsvpResponse == response ? "active" : ""}
          >
            { response }
          </a>
        </li>
        );
      }
    );
    return (
      <ul className="response-buttons" >
        { responses }
      </ul>
    )
  },
  changeResponse: function(response, e) {
    e.preventDefault();
    if (!this.props.formSubmitting) {
      actions.setRsvpResponse(response);
    }
  }
});

const ReplyingAs = React.createClass({
  componentDidUpdate: function(prevProps) {
    if (!prevProps.editingName && this.props.editingName) {
      findDOMNode(this.refs.nameInput).focus()
    }
  },
  render: function() {
    const allowInviteMore = window.evite_event.options.event_option_allow_invite_more;
    const placeHolder = window.user_is_registered ? "Name" : this.props.guestName;
    return (
      <div className="replying-as">
        Replying as:
        { this.props.editingName ?
          <span>
            <span className="change-name-input">
              <input
                type="text"
                maxLength="50"
                value={this.props.altGuestName}
                ref="nameInput"
                onChange={this.handleAltNameChange}
                placeholder="Name"
              />
              { window.user_is_registered &&
                <a
                  href="#"
                  onClick={this.handleCancelChangeNameClick}
                >
                  <i className="icon-cancel"></i>
                </a>
              }
              { this.props.validationErrors.guestName &&
                <span className="validation-error">
                  { this.props.validationErrors.guestName }
                </span>
              }
            </span>
            { !window.is_premium && !window.user_is_registered && allowInviteMore &&
              <a href="#" onClick={this.handleNotYouClick}>
                <small> Not you?</small>
              </a>
            }
          </span>
        :
          <span>
            <b>&nbsp;{this.props.guestName}&nbsp;</b>
            <a href="#" onClick={this.handleChangeNameClick}>
              <small>Edit</small>
            </a>
            { !window.is_premium && allowInviteMore &&
              <a href="#" onClick={this.handleNotYouClick}>
                <small> | Not you?</small>
              </a>
            }
          </span>
        }
      </div>
    )
  },
  handleAltNameChange: function(e) {
    actions.setAltGuestName(e.target.value);
  },
  handleCancelChangeNameClick: function(e) {
    e.preventDefault();
    actions.setEditingGuestName(false, "");
  },
  handleChangeNameClick: function(e) {
    e.preventDefault();
    actions.setEditingGuestName(true, this.props.guestName);
  },
  handleNotYouClick: function(e) {
    e.preventDefault();
    actions.setNotYou();
  }
});

const NameEmailInputs = React.createClass({
  render: function() {
    return (
      <fieldset className="rsvp-name-email">
        { this.props.storedGuestName &&
          <a href="#"
            onClick={ this.handleCancelNotYou }
            className="cancel-not-you"
          >
            Cancel
          </a>
        }
        <span className="input-wrap">
          <input
            type="text"
            placeholder="Name"
            value={this.props.guestName}
            onChange={this.handleNameChange}
            maxLength="50"
            disabled={this.props.formSubmitting}
            required
          />
          { this.props.validationErrors.guestName &&
            <span className="validation-error">
              { this.props.validationErrors.guestName }
            </span>
          }
        </span>
        <span className="input-wrap">
          <input
            type="email"
            placeholder="Email"
            value={ this.props.guestEmail }
            onChange={ this.handleEmailChange }
            maxLength="50"
            disabled={this.props.formSubmitting}
            required
          />
          { this.props.validationErrors.guestEmail &&
            <span className="validation-error">
              { this.props.validationErrors.guestEmail }
            </span>
          }
        </span>
      </fieldset>
    )
  },
  handleNameChange: function(e) {
    actions.setGuestName(e.target.value);
  },
  handleEmailChange: function(e) {
    actions.setGuestEmail(e.target.value);
  },
  handleCancelNotYou: function(e) {
    e.preventDefault();
    actions.unsetNotYou();
  }
});

const TotalGuests = React.createClass({
  render: function() {
    if (this.props.allowKids) {
      return (
        <fieldset className="total-guests">
          <div className="total-adults">
            <input
              type="number"
              id="total-adults-input"
              min="0"
              max={this.props.maxGuests}
              value={this.props.totalAdults}
              onChange={this.handleTotalAdultsChange}
              disabled={this.props.formSubmitting}
              required
            />
            <label htmlFor="total-adults-input">
              Total adults
              { this.props.validationErrors.totalAdults &&
                <span className="validation-error">
                  {this.props.validationErrors.totalAdults}
                </span>
              }
              <span className="desc">
                 (including you)
              </span>
            </label>
          </div>
          <div className="total-kids">
            <input
              type="number"
              id="total-kids-input"
              min="0"
              max={this.props.maxGuests}
              value={this.props.totalKids}
              onChange={this.handleTotalKidsChange}
              disabled={this.props.formSubmitting}
              required
            />
            <label className="last" htmlFor="total-kids-input">
              Total kids
              { this.props.validationErrors.totalKids &&
                <span className="validation-error">
                  {this.props.validationErrors.totalKids}
                </span>
              }
            </label>
          </div>
        </fieldset>
      )
    } else {
      return (
        <fieldset className="total-guests">
          <input
            type="number"
            id="total-adults-input"
            min="1"
            max={this.props.maxGuests}
            value={this.props.totalAdults}
            onChange={this.handleTotalAdultsChange}
            disabled={this.props.formSubmitting}
            required
          />
          <label htmlFor="total-adults-input">
            Total guests
            { this.props.validationErrors.totalAdults &&
              <span className="validation-error">
                {this.props.validationErrors.totalAdults}
              </span>
            }
            <span className="desc">
               (including you)
            </span>
          </label>
        </fieldset>
      )
    }
  },
  handleTotalAdultsChange: function(e) {
    actions.setTotalAdults(e.target.value);
  },
  handleTotalKidsChange: function(e) {
    actions.setTotalKids(e.target.value);
  }
});

const NotificationInputs = React.createClass({
  render: function() {
    return (
      <fieldset id="notify-marketing-wrap">
        <input
          type="checkbox"
          id="notify-marketing"
          checked={this.props.notifyMarketing}
          onChange={this.handleMarketingChanged}
          disabled={this.props.formSubmitting}
        />
        <label htmlFor="notify-marketing">
          <span></span>
          I'd like to receive party secrets, gift ideas, special offers and more.
        </label>
      </fieldset>
    )
  },
  handleMarketingChanged: function() {
    actions.setNotifyMarketing(!this.props.notifyMarketing);
  }
});

const EventActions = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  printUrl: function () {
    if (window.is_premium) {
      return urls.get('print_event_premium', {
        event_id: window.evite_event.id,
        guest_id: window.guest_id
      });
    } else {
      return urls.get('print_event', {
        event_id: window.evite_event.id

      });
    }
  },
  render: function() {
    const eviteEvent = window.evite_event;
    const showMap = (eviteEvent.street_address || eviteEvent.city || eviteEvent.state || eviteEvent.zip_code);
    const mapUrl = urls.get('event_map_redirect', {
        event_id: eviteEvent.id,
        guest_id: window.guest_id
      });

    if(utils.isMobile()){
      return (
        <div className="event-actions">
          { utils.hasRsvpd() &&
          <AddToCalendar data-source="invite"/>
          }
        </div>
      );
    }

    return (
      <div className="event-actions">
        { showMap &&
          <a href={mapUrl} target="_blank">
            <i className="icon-map"></i> View Map
          </a>
        }
        <a href={ this.printUrl() } target="_blank">
          <i className="icon-print"></i> Print Invitation
        </a>
        { utils.hasRsvpd() &&
          <AddToCalendar data-source="invite" />
        }
      </div>
    );
  }
});

const FromHostPanel = React.createClass({
  shouldComponentUpdate: function(nextProps, nextState) {
    return false;
  },
  render: function() {
    const { hasPoll, hasWhatToBring } = this.props;
    const hasDonate = window.donations_enabled;
    const hasRegistry = Boolean(window.evite_event.registries);
    const hasWishlist = window.wishlist_enabled;
    const hasAddedItems = hasPoll || hasWhatToBring || hasRegistry || hasWishlist || hasDonate;
    const registryIconClassName = "icon-registry_" + window.gift_registry_provider;
    if (window.host_message || hasAddedItems) {
      return (
        <div className="simple-shadowbox from-host-panel">
          { window.host_message &&
            <HostMessage />
          }
          { hasAddedItems &&
            <div className="host-panel host-has-added">
              <h3>Your host has added:</h3>
              <ul>
                { hasPoll &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("polls")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className="icon-polls"></i> Poll
                    </RouterLink>
                  </li>
                }
                { hasWhatToBring &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("what-to-bring")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className="icon-wtb"></i> What To Bring
                    </RouterLink>
                  </li>
                }
                { hasRegistry && !hasWishlist &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("gifts")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className={registryIconClassName}></i> Registry
                    </RouterLink>
                  </li>
                }
                { hasWishlist && !hasRegistry &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("gifts")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className="icon-wishlist"></i> Wish List
                    </RouterLink>
                  </li>
                }
                { hasDonate &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("donate")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className="icon-donations"></i> Donate
                    </RouterLink>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      )
    } else {
      return null;
    }
  }
});

const HostMessage = React.createClass({
  shouldComponentUpdate: function(nextProps, nextState) {
    return this.state.minimized !== nextState.minimized;
  },
  getInitialState: function() {
    return {
      minimized: false,
      heightThreshold: utils.isMobile() ? 400 : 900
    }
  },
  componentDidMount: function() {
    if (this.hostMessageWrapper && this.hostMessageWrapper.offsetHeight > this.state.heightThreshold) {
      this.setState({minimized: true});
    }
  },
  render: function() {
    const hostMessage = window.host_message;
    const isMinimized = this.state.minimized;
    return (
      <div
        className={`message-from-host ${isMinimized ? "minimized" : ""}`}
        style={isMinimized ? { maxHeight: this.state.heightThreshold + "px" } : {}}
        ref={(c) => this.hostMessageWrapper = c}
        id="host-message"
      >
        { !window.is_premium &&
          <h3>Message from Host</h3>
        }

        <div dangerouslySetInnerHTML={{__html: hostMessage}} />
        { isMinimized &&
          <div className="message-from-host-overlay">
            <button
              className="button-primary-inverse small"
              onClick={this.handleShowMoreClick}
            >
              Show more
            </button>
          </div>
        }
      </div>
    )
  },
  handleShowMoreClick: function(e) {
    e.preventDefault();
    this.setState({minimized: false});
  }
});

const MobileInvitationDesign = React.createClass({
  componentDidMount () {
    evite.when('block js').then(() => {
      if (window.is_premium && window.NavigationView) {
        window.NavigationView.initPremiumInvitationNav();
      }
    });
  },
  shouldComponentUpdate() {
    return false;
  },
  componentWillMount() {
    const node = document.getElementById('design-template-wrapper');
    this.designMarkup = node.innerHTML;
  },
  render() {
    return (
      <div
        id="invitation_container"
        dangerouslySetInnerHTML={{__html: this.designMarkup}}
      />
    )
  }
});

const AddToCalendar = React.createClass({
  render() {
    let text = this.props.text || this.props.title;

    return (
      <a
        id="add-to-calendar"
        className={this.props.className}
        href='javascript:void(0)'
        title={this.props.title}
        data-type={this.props['data-type']}
        data-source={this.props['data-source']}
        data-action={this.props['data-action']}
        onClick={this.handleClick}
      >
        <i className="icon-calendar-plus"></i>
        {text}
      </a>
    );
  },

  handleClick(event) {
    event.preventDefault();

    const isMobile = utils.isMobile();
    if(isMobile) {
      this.downloadCalendarEvent();
    } else {
      const addToCalendarModal = this.createAddToCalendarModal();
      addToCalendarModal.show();
    }

    return false;
  },

  downloadCalendarEvent(){
    location.href = `${ location.origin }/event/${ window.event_id }/export/ical/?gid=${ window.guest_id }`;
  },

  createAddToCalendarModal(){
    const isMobile = utils.isMobile();

    return new ModalView({
        url: urls.get('modal_add_to_calendar', {
          event_id: window.evite_event.id
        }),
        url_parameters: {
          guest_id: window.guest_id,
          is_mobile: utils.isMobile()
        }
      });
  }
});

AddToCalendar.defaultProps = {
  className: '',
  text: '',
  title: 'Add to Calendar',
  'data-action': 'download',
  'data-source': '',
  'data-type': 'calendar',
};

function mapStateToProps(state) {
  return {
    state: {
      hasPoll: state.polls.length > 0,
      hasWhatToBring: state.whattobring.creator_id,
      rsvp: state.rsvp
    }
  }
}

const connectedRsvp = connect(mapStateToProps)(Rsvp);

export default connectedRsvp;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/components.es6